import { EditOutline18Icon, TrainFill18Icon } from "@vygruppen/spor-icon-react";
import { SummaryPreview } from "features/CenterContent/RoleContent/ProductionDeviation/components/SummaryPreview";
import { TrainBadges } from "features/CenterContent/RoleContent/ProductionDeviation/components/TrainBadges";
import { ProductionDeviationForm } from "features/CenterContent/RoleContent/ProductionDeviation/types/formSchema";
import { useProductionDeviationPath } from "features/CenterContent/RoleContent/ProductionDeviation/utils";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { HStack, IconButton, Separator, VStack } from "shared/components/Spor";
import { Step } from "shared/components/stepper/DropsStepper";
import { Text } from "shared/components/typography/TitleStyles";

type ProductionDeviationOverviewTrainSeriesProps = {
  trainSerie: string;
  toStep: () => void;
};

export const ProductionDeviationOverviewTrainSeries: FC<
  ProductionDeviationOverviewTrainSeriesProps
> = ({ trainSerie, toStep }) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<ProductionDeviationForm>();
  const { path } = useProductionDeviationPath(trainSerie);
  const trainIds = watch(path("selectedTrains")) ?? [];
  return (
    <HStack w="100%" alignItems="stretch" position="relative">
      <VStack flex={1} alignItems="start">
        <Text secondary>{t("Togserie")}:</Text>
        <Step $active={false}>
          <TrainFill18Icon />
          <Text>{trainSerie}</Text>
        </Step>
      </VStack>
      <Separator orientation="vertical" h="auto" />
      <VStack flex={1} alignItems="start">
        <Text secondary>{t("Gjeldende tog")}:</Text>
        <HStack wrap="wrap" mr="6px">
          <TrainBadges trainIds={trainIds} />
        </HStack>
      </VStack>
      <Separator orientation="vertical" h="auto" />
      <VStack flex={1} alignItems="start">
        <Text secondary>{t("Oppsummering")}:</Text>
        <SummaryPreview trainSerie={trainSerie} />
      </VStack>
      <Separator orientation="vertical" h="auto" />
      <IconButton
        alignSelf="start"
        onClick={toStep}
        size="xs"
        aria-label={t("Rediger")}
        variant="tertiary"
        icon={<EditOutline18Icon />}
      />
    </HStack>
  );
};
